function initMap() {
    var frdivise = { lat: 50.037, lng: 14.580 };
    var mapcenter = { lat: 50.062, lng: 14.534 };
    var iconBase = '/wp-content/themes/JointsWP/assets/images/';
    var mapaFeatures = {
        center: mapcenter,
        zoom: 12,
        scrollwheel: 0,
        draggable: 1,
        disableDefaultUI: 0,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{
            featureType: "administrative",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#444444"
            }]
        }, {
            featureType: "landscape",
            elementType: "all",
            stylers: [{
                color: "#f2f2f2"
            }]
        }, {
            featureType: "poi",
            elementType: "all",
            stylers: [{
                lightness: "-18"
            }, {
                visibility: "on"
            }, {
                saturation: "-100"
            }]
        }, {
            featureType: "road",
            elementType: "all",
            stylers: [{
                saturation: -100
            }, {
                lightness: 45
            }]
        }, {
            featureType: "road.highway",
            elementType: "all",
            stylers: [{
                visibility: "simplified"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "labels.icon",
            stylers: [{
                visibility: "off"
            }]
        }, {
            featureType: "transit",
            elementType: "all",
            stylers: [{
                visibility: "off"
            }]
        }, {
            featureType: "water",
            elementType: "all",
            stylers: [{
                color: "#4f595d"
            }, {
                visibility: "on"
            }]
        }]
    }
    var map = new google.maps.Map(
        document.getElementById('mapa'), mapaFeatures);
    var marker = new google.maps.Marker({
        position: frdivise,
        map: map,
        icon: iconBase + 'marker.png'
    });
}